import React from 'react'
import PropTypes from 'prop-types'
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import theme from '../../config/styles/theme'
import exportToImage from '../../modules/utils/exports'
import { formatAmount, formatPercentage } from '../../modules/utils/formatters'
import { GlobalStyle, Exportable } from './LineChart.styles'

const HorizontalBarsChart = ({ inputHorizontalBarChartRef, id, info, categories, fileName }) => {
  const options = {
    accessibility: { enabled: false },
    title: {
      text: ''
    },
    chart: {
      type: 'bar',
      height: 400
    },
    yAxis: {
      title: {
        text: ''
      }
    },
    xAxis: {
      categories,
      min: 0,
      gridLineDashStyle: 'ShortDash',
      gridLineWidth: 1,
      startOnTick: false,
      endOnTick: true
    },
    series: [
      {
        data: info,
        dataLabels: [
          {
            backgroundColor: 'rgba(255,255,255,0.9)',
            x: 10,
            padding: 10,
            allowOverlap: true,
            style: {
              color: theme.palette.brand.black1,
              fontSize: '11px',
              textOutline: 'none'
            },
            formatter: function () {
              return `
                <span style="font-weight:bold;">
                  $${formatAmount(this.y)} (${formatPercentage(this.point.percentage)})
                </span>
                <br />
                <span style="color: #768AA2;">
                  ${formatAmount(this.point.orders)} órdenes de compra
                </span>
                <br />
              `
            }
          }
        ]
      }
    ],
    tooltip: {
      enabled: false
    },
    plotOptions: {
      bar: {
        minPointLength: 5,
        color: theme.palette.charts.navyBlue
      },
      series: {
        pointWidth: 35,
        dataLabels: {
          enabled: true
        }
      }
    }
  }

  const exportData = () => {
    exportToImage(id, fileName)
  }

  return (
    <>
      <GlobalStyle />
      <Exportable id={id}>
        <HighchartsReact highcharts={Highcharts} options={options} />
        <Exportable onClick={exportData} ref={inputHorizontalBarChartRef} />
      </Exportable>
    </>
  )
}

HorizontalBarsChart.defaultProps = {
  info: [],
  id: 'horizontalBarChart'
}

HorizontalBarsChart.propTypes = {
  id: PropTypes.string,
  info: PropTypes.arrayOf(
    PropTypes.shape({
      amount: PropTypes.number,
      catName: PropTypes.string,
      orders: PropTypes.number,
      y: PropTypes.number
    })
  ),
  categories: PropTypes.arrayOf(PropTypes.string).isRequired,
  inputHorizontalBarChartRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.instanceOf(window.HTMLDivElement) })
  ]),
  fileName: PropTypes.string.isRequired
}

export default HorizontalBarsChart
